import { FC } from 'react';
import { Carousel } from 'react-responsive-carousel';
import 'react-responsive-carousel/lib/styles/carousel.min.css';

import styles from './PredefinedReviews.module.scss';

const MobileCarousel: FC<any> = ({ children }) => (
  <Carousel
    swipeable
    showArrows={false}
    className={styles.blogCarousel}
    showStatus={false}
    showThumbs={false}
    infiniteLoop
  >
    {children}
  </Carousel>
);

export default MobileCarousel;
